import NotificationsIcon from '@material-ui/icons/Notifications';
import { icon_user_circle } from 'components/base/images';
import ImgCrop from 'components/common/images/ImgCrop';
import { AppContext } from 'contexts/AppContext';
import { cutUrl } from 'lib/library';
import { pageUrl } from 'lib/mapper';
import storage from 'lib/storage';
import { useDidUpdateEffect } from 'lib/utils';
import queryString from 'query-string';
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import {
  NotificationActions,
  UtilActions
} from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { isLogInSelector } from 'store/modules/auth';
import styled from 'styled-components';
import { color } from 'styles/utils';

function AppHeader() {
  const {
    language,
    isLogIn,
    user,
    newNotificationData: { newNotificationCount },
    officialNotifications,
    signInUrl,
    signInUrlSuccess,
    signUpUrl,
    signUpUrlSuccess,
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    isLogIn: isLogInSelector(state),
    user: state.user.user,
    newNotificationData: state.notification.newNotifications.data || {},
    officialNotifications: state.notification.officialNotifications.data?.list,
    signInUrl: state.auth.signInAuth.data?.connectUrl,
    signInUrlSuccess: state.auth.signInAuth.success,
    signUpUrl: state.auth.signUpAuth.data?.connectUrl,
    signUpUrlSuccess: state.auth.signUpAuth.success,
  }));

  const location = useLocation();
  const { pathname, search, state } = location as { pathname: string; search: string; state: any };
  const queryParse = queryString.parse(search);
  const from = state?.hasOwnProperty('from') ? state.from : { pathname };
  // NOTE: ErrorContainer 에서 returnPath 넘겨줬을 경우, PrivateRoute에서 from을 넘겨줬을경우
  const returnPath = queryParse?.returnPath || from.pathname;
  const currentPath = cutUrl(pathname);
  const isDashboardPage = currentPath === 'home' || currentPath === 'dashboard';
  const isShowOfficialNotifications = !['project'].includes(currentPath);

  const currentPathFull = `${cutUrl(pathname)}/${cutUrl(pathname, 1)}`;
  const isExceptedProjectPage = [
    pageUrl.project.create.new,
    pageUrl.project.create.patient,
    pageUrl.project.edit,
    pageUrl.project.detail,
  ].includes(pathname);

  // console.log('currentPathFull ____ ', currentPathFull);
  // const isShowUserName = useMemo(() => {
  //   return ['project/detail', 'project/create', 'project/edit'].includes(currentPathFull);
  // }, [currentPathFull]);

  const history = useHistory();
  const alarmCountRef = useRef<null | any>(null);
  const [alarmCountHeight, setAlarmCountHeight] = useState(0);
  const { uiDraggable, setUiDraggable } = useContext(AppContext);

  // SECTION: function
  // const handleToggleNav = (path: string) => {
  //   history.push(`/${path}`);
  // };

  const handleToggleCustomizeUi = () => {
    setUiDraggable(!uiDraggable);
  };

  // TEST:
  // useEffect(() => {
  //   console.log('history', history);
  // }, []);

  // SECTION: DidMount

  useEffect(() => {
    UtilActions.fetch_currency_list_request();
    setUiDraggable(null);
  }, []);

  useLayoutEffect(() => {
    if (!!alarmCountRef.current) {
      setAlarmCountHeight(alarmCountRef.current.clientWidth || 0);
    }
  }, [alarmCountRef.current]);

  useEffect(() => {
    if (isShowOfficialNotifications) {
      NotificationActions.fetch_official_notifications_request({
        language: language.toUpperCase(),
      });
    }
  }, [isShowOfficialNotifications]);

  // SECTION: DidUpdate

  // returnPath 저장 후 이동
  useDidUpdateEffect(() => {
    if (signInUrlSuccess) {
      // console.log('loginUrlSuccess _____ >> ', connectUrl);
      window.location.href = signInUrl;
      storage.set('returnPath', returnPath);
    }
  }, [signInUrlSuccess === true]);

  useDidUpdateEffect(() => {
    if (signUpUrlSuccess) {
      // console.log('loginUrlSuccess _____ >> ', connectUrl);
      window.location.href = signUpUrl;
      storage.set('returnPath', returnPath);
    }
  }, [signUpUrlSuccess === true]);

  return (
    <Styled.AppHeader data-component-name="AppHeader" isExceptedProjectPage={isExceptedProjectPage}>
      <header className="header">
        <div className="header__title_box">
          <h1>
            {/* <Link to="/" className="header__logo_box">
            <img src={logo} alt="Logo" className="header__logo" />
            <LogoSyncText />
          </Link> */}
            <span className="sr-only">DOF Sync</span>
          </h1>
          {/* {isShowOfficialNotifications && (
            <div className="header__notice">
              <img src={icon_loud_speaker} alt="notice icon" className="header__notice_icon" />
              <div className="header__notice_list">
                <VerticalSlider data={officialNotifications} />
              </div>
            </div>
          )} */}
        </div>
        <div className="header__menu_container">
          {/* {!isExceptedProjectPage && (
            <div className="header__toggle_menu">
              <ul className="header__toggle_menu_list">
                {['Store', 'Notifications'].map((item, idx) => {
                  const itemIndex = item.toLowerCase();
                  return (
                    <li
                      className={cx('header__toggle_menu_item', {
                        active: currentPath === itemIndex,
                      })}
                      key={idx}
                      onClick={() => handleToggleNav(itemIndex)}
                    >
                      <span className="header__toggle_menu_item_mark"></span>
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          )} */}
          <div className="header__auth_menu">
            <ul className="header__menu_list auth">
              {/* {isLogIn ? (
                <li
                  className={cx('header__menu_item sign cursor-pointer', {
                    active: pathname === pageUrl.auth.signOut,
                  })}
                  onClick={handleSignOut}
                >
                  out
                  
                </li>
              ) : (
                <li
                  className={cx('header__menu_item sign cursor-pointer', {
                    active: pathname === pageUrl.auth.signIn,
                  })}
                  onClick={() => handleConnectAuth('signIn')}
                >
                  Login
                  
                </li>
              )} */}
              {/* {isDashboardPage && (
                <li className="header__menu_item setting">
                  <button className="btn-reset" onClick={handleToggleCustomizeUi}>
                    <SettingsIcon
                      fontSize="large"
                      htmlColor={uiDraggable ? '#0782ED' : color.gray_b5}
                    />
                  </button>
                </li>
              )} */}
              {isLogIn && (
                <li className="header__menu_item alarm">
                  <NavLink to={pageUrl.notifications.index} className="header__link_alarm">
                    {/* <img src={icon_alert_bubble} alt="notifications" className="header__alarm_icon" /> */}
                    <NotificationsIcon fontSize="large" htmlColor={'#CED2DF'} />

                    {!!newNotificationCount && (
                      <span
                        className="header__alarm_count"
                        ref={alarmCountRef}
                        style={{
                          height: `${alarmCountHeight}px`,
                        }}
                      >
                        {newNotificationCount}
                      </span>
                    )}
                  </NavLink>
                </li>
              )}
              <li className="header__menu_item account">
                {/* {ENV_MODE_DEV && <span className="header__account_name">{user?.name}</span>} */}

                <NavLink to={pageUrl.user.index} className="header__link_account">
                  {user?.profileImg ? (
                    // <ImgCrop width={52} isCircle src={user.profileImg} alt="profile" />
                    <ImgCrop width={40} isCircle src={user.profileImg} alt="profile" />
                  ) : (
                    <img src={icon_user_circle} alt="account" />
                  )}
                </NavLink>
                {/* {!isShowUserName && (
                )} */}
                <div className="header__account_name_box">
                  <NavLink to={pageUrl.user.index}>
                    <p className="header__account_company">
                      {/* {user?.company} */}
                      {user?.name}
                    </p>
                  </NavLink>
                  <NavLink to={pageUrl.user.index}>
                    <p className="header__account_email">{user?.email}</p>
                  </NavLink>
                </div>
                {/* <p className="header__account_name">
                  디오에프연구소
                  <br />
                  jun@doflab.com
                </p> */}
              </li>
            </ul>
          </div>
        </div>
      </header>
    </Styled.AppHeader>
  );
}

export const headerHeightOld = 120;
// export const headerHeight = 110;
export const headerHeight = 70;
export const headerPaddingBottom = 20;

const Styled = {
  AppHeader: styled.div<{ isExceptedProjectPage: boolean }>`
    /* position: relative; */
    position: absolute;
    width: 100%;
    /* height: 90px; */
    top: 0;
    left: 0;
    z-index: 1200;
    padding-right: 24px;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 100%;
      height: ${headerHeight}px;
      /* padding-bottom: ${headerPaddingBottom}px; */
      padding-left: 260px;
      /* margin-right: 24px; */
      /* padding-right: 50px; */
      /* padding-top: ${({ isExceptedProjectPage }) => isExceptedProjectPage && '15px'}; */
      /* background-color: #fff; */
      /* border-bottom: 1px solid #ddd; */
    }
    .header {
      /* position: fixed;
      top: 0;
      left: 0; */
      /* text-align: center; */
      display: flex;
      align-items: center;
    }
    .header__logo_box {
      display: flex;
      align-items: center;
      .header__logo {
        margin-right: 25px;
      }
    }
    .header__notice {
      display: flex;
      align-items: center;
      position: relative;
      width: 1070px;
      height: 60px;
      padding: 10px 35px;
      padding-left: 80px;
      background-color: #edf4fb;
      border-radius: 30px;
      .header__notice_icon {
        /* margin-right: 25px; */
        position: absolute;
        left: 10px;
        top: 0;
        width: 60px;
        height: 60px;
      }
      .header__notice_list {
        width: calc(100% - 50px);
        height: 17px;
        .header__notice_item {
          height: 17px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .header__menu_container {
      display: flex;
      align-items: center;
    }
    .header__menu_list {
      display: flex;
      align-items: center;
    }
    .header__menu_item {
      position: relative;
      &:not(:first-of-type) {
        /* margin-left: 20px; */
        margin-left: 16px;
      }
      &.active {
        text-decoration: underline;
      }
      &.sign {
        margin-right: 5px;
      }
      &.account {
        display: flex;
        align-items: center;
        .header__account_name_box {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 16px;
          width: 178px;
          height: 42px;
          p {
            width: 178px;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .header__account_company {
            font-size: 14px;
            font-weight: 700;
            color: #303030;
            line-height: 19px;
          }
          .header__account_email {
            font-size: 11px;
            font-weight: 200;
            color: #303030;
            line-height: 15px;
          }
        }
        .header__account_name {
          /* text-align: left;
          margin-left: 20px;
          line-height: 1.3; */
          position: absolute;
          top: -20px;
          right: 0;
          width: 500px;
          font-size: 12px;
          text-align: right;
        }
      }
      .header__link {
      }
      .header__link_alarm {
        display: inline-block;
        position: relative;
        top: 3px;
        .header__alarm_icon {
        }
        .header__alarm_count {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: -7px;
          right: -5px;
          padding: 3px;
          min-width: 22px;
          min-height: 22px;
          background-color: ${color.blue};
          border-radius: 50%;
          font-size: 12px;
          font-weight: 500;
          color: white;
          letter-spacing: -0.5px;
        }
      }
      .header__link_account {
        display: inline-block;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0 0px 6px 1px rgba(0, 0, 0, 0.16);
        overflow: hidden;
        padding: 0;
        line-height: 0;
        img {
          /* width: 52px; */
          width: 42px;
        }
      }
    }
    .header__auth_menu {
    }
    .header__toggle_menu {
      margin-right: 35px;
      .header__toggle_menu_list {
        display: flex;
        align-items: center;
        .header__toggle_menu_item {
          display: flex;
          align-items: center;
          height: 40px;
          padding-right: 25px;
          border: 1px solid ${color.navy_blue};
          border-radius: 20px;
          font-size: 13px;
          &:not(:first-child) {
            margin-left: 25px;
          }
          .header__toggle_menu_item_mark {
            display: inline-flex;
            margin-right: 20px;
            width: 40px;
            height: 40px;
            border-radius: 20px;
            background-color: ${color.navy_blue};
          }
          &.active {
            flex-direction: row-reverse;
            padding-right: 0;
            padding-left: 25px;
            .header__toggle_menu_item_mark {
              margin-right: 0px;
              margin-left: 20px;
            }
          }
        }
      }
    }
  `,
};

export default AppHeader;
